type HeroSectionProps = {
  headline: string
  subheadline: string
  ctaText: string
  ctaLink: string
  image?: string
}

export default function HeroSection({
  headline,
  subheadline,
  ctaText,
  ctaLink,
}: HeroSectionProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6 text-gray-900">{headline}</h1>
          <p className="text-xl text-gray-600 mb-8">{subheadline}</p>
          <a
            href={ctaLink}
            className="inline-block bg-brand-green text-white px-8 py-3 rounded-lg font-semibold hover:bg-brand-green-dark transition"
          >
            {ctaText}
          </a>
        </div>
      </div>
    </section>
  )
}
